// @react/hooks/useSubscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionStore } from '@core/stores';

/**
 * React hook for Subscription operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscription } from '@react/hooks';
 *
 * const SubscriptionList = observer(() => {
 *   const store = useSubscription();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscription() {
  return subscriptionStore;
}
